import React from 'react';
import PropTypes from 'prop-types';

const QrIcon = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12V17C1 18.1046 1.89543 19 3 19H8" stroke={color} stroke-linecap="round"/>
<path d="M19 12V17C19 18.1046 18.1046 19 17 19H12" stroke={color} stroke-linecap="round"/>
<path d="M8 1L3 1C1.89543 1 1 1.89543 1 3L1 8" stroke={color} stroke-linecap="round"/>
<path d="M12 1L15.5 1L17 1C18.1046 1 19 1.89543 19 3L19 8" stroke={color} stroke-linecap="round"/>
<rect x="5" y="11" width="4" height="4" rx="0.5" stroke={color}/>
<rect x="5" y="5" width="4" height="4" rx="0.5" stroke={color}/>
<rect x="11" y="11" width="4" height="4" rx="0.5" stroke={color}/>
<rect x="11" y="5" width="4" height="4" rx="0.5" stroke={color}/>
</svg>
);

QrIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default QrIcon; 